import { PlanEnum } from "@/__generated__/graphql";

export const getPlanDisplayName = (plan: PlanEnum): string => {
  switch (plan) {
    case PlanEnum.Sandbox:
      return "Free Trial";
    case PlanEnum.Free:
      return "Release Cloud";
    case PlanEnum.Enterprise:
      return "Enterprise - Runs in your cloud";
    case PlanEnum.Professional:
      return "Teams (Legacy Professional)";
    case PlanEnum.Starter:
      return "Starter - This plan is no longer supported, please upgrade to one of the available plans";
    case PlanEnum.Teams:
      return "Teams";
    default:
      return plan;
  }
};
